import React from 'react';
import { customParseFloat } from '../../../../helpers/array';


const BalanceField = ({role, amount, onClick}) => {

  return (
    <React.Fragment>
      <span className={`${role}Icon`}></span>
      <span className={`balanceNumber`}>{customParseFloat(amount)}</span>
    </React.Fragment>
  )
}

export default BalanceField;
